import type { ComponentProps } from 'react';

import { cn } from '@/design-system/lib/cn';

/** Bloco com brilho (1,2s linear) que ocupa o lugar do conteúdo enquanto carrega. */
export function Skeleton({ className, ...props }: ComponentProps<'span'>) {
  return (
    <span
      aria-hidden
      className={cn('block animate-shimmer rounded-chip bg-skeleton', className)}
      {...props}
    />
  );
}
